import request from '@/utils/request'

/**
 * 查询传记
 * @param {*} data
 * @returns
 */
export function allBiographie (data) {
  return request({
    url: '/zstp/neo4j/get_all_biographie/',
    method: 'post',
    data
  })
}

/**
 * 传记记载
 * @param {*} data
 * @returns
 */
export function personRecordedIn (data, others = {}) {
  return request({
    url: '/zstp/neo4j/person_recorded_in/',
    method: 'post',
    ...others,
    data
  })
}
/**
 * 传记详情
 * @param {*} data
 * @returns
 */
export function biographieDetail (data) {
  return request({
    url: '/zstp/neo4j/biographie_detail/',
    method: 'post',
    data
  })
}

/**
 * 传记记载详情
 * @param {*} data
 * @returns
 */
export function recordedInDetail (data) {
  return request({
    url: '/zstp/neo4j/recorded_in_detail/',
    method: 'post',
    data
  })
}
